import * as React from 'react';

import * as styles from './FiltersFooterLayout.css';

export const FiltersFooterLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
